import axios from 'src/app-axios';
import Constants from 'src/constants';

export const userprofile = {
  namespaced: true,
    state: {
      userDetails: {},
      userActivities: [],
      organizationSettings: [],
    },
    getters: {
      getUserDetails (state) {
        return state.userDetails;
      },
      getUserActivities (state) {
        return state.userActivities;
      },
      getOrganizationSettings (state) {
        return state.organizationSettings;
      },
    },
    actions: {
      async fetchUserDetails ({ dispatch, commit }) {
        const url = 'api/devices/service-providers';
        try {
          const details = await axios.get(url);
          commit('setUserDetails', details.data);
        } catch (exception) {
          dispatch('alert/onAlert', {
            message: 'Something went wrong in getting the user details.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
        }
      },
      async updateUserDetails ({ dispatch }, payload) {
        const url = 'api/devices/service-providers/update';
        try {
          await axios.put(url, payload.details);
        } catch (exception) {
            dispatch('alert/onAlert', {
                message: 'Something went wrong in updating your details.',
                type: Constants.ALERT_TYPE_ERROR,
            }, { root: true });
            throw exception;
        }
      },
      async fetchUserActivities ({ dispatch, commit }) {
        const url = 'api/devices/service-providers/activity';
        try {
          const activities = await axios.get(url);
          commit('setUserActivities', activities.data);
        } catch (exception) {
          dispatch('alert/onAlert', {
            message: 'Something went wrong in getting the user activity data.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
        }
      },
      async fetchFilteredActivities ({ dispatch, commit }, payload) {
        const url = 'api/devices/service-providers/activity';
        try {
          const activities = await axios.get(url, payload);
          commit('setUserActivities', activities.data);
        } catch (exception) {
          dispatch('alert/onAlert', {
            message: 'Something went wrong in getting the user activity data.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
        }
      },
      async fetchOrganizationSettings ({ dispatch, commit }) {
        const url = 'api/devices/organizations/modules';
        try {
          const modules = await axios.get(url);
          commit('setOrganizationSettings', modules.data);
        } catch (exception) {
          dispatch('alert/onAlert', {
            message: 'Something went wrong in getting the organization settings data.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
        }
      },
    },
    mutations: {
      setUserDetails (state, details) {
        state.userDetails = details;
      },
      setUserActivities (state, activities) {
        state.userActivities = activities;
      },
      setOrganizationSettings (state, modules) {
        state.organizationSettings = modules;
      },
    },
};
